<template>
  <div v-if="product">
    <el-card class="card card__product" :class="{ 'is-favorite': isFavorite }">
      <router-link
        v-if="product.hasDetail"
        class="product__link"
        :to="productDetailRoute"
      >
        <header class="card__header">
          <h4 class="h6 font-family-body">{{ categoryParents }}</h4>
          <h4 class="h5 font-family-body">{{ product.title }}</h4>
        </header>
        <div class="card__media">
          <img v-if="mainImageUrl" :src="mainImageUrl" />
          <img v-else :src="fallbackJpg" />
        </div>
      </router-link>
      <router-link
        v-else
        class="product__link"
        :to="productDetailRoute"
      >
        <header class="card__header">
          <h4 class="h6 font-family-body">{{ categoryParents }}</h4>
          <h4 class="h5 font-family-body">{{ product.title }}</h4>
        </header>
        <div class="card__media">
          <img v-if="mainImageUrl" :src="mainImageUrl" />
          <img v-else :src="fallbackJpg" />
        </div>
      </router-link>
      <div class="card__actions">
        <el-button-group>
          <el-button
            @click.prevent="handleToggleFavorite"
            :class="{ active: isFavorite }"
            type="text"
            native-type="button"
          >
            <svg
              width="19"
              height="18"
              viewBox="0 0 19 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path :d="starIconFilled" fill="currentColor" />
            </svg>
            <!--TODO Added new translation string "Add to Favorites" to Product section.-->
            <span class="sr-only sr-only-focusable">{{
              $t('productCardFavorite')
            }}</span>
          </el-button>
          <el-button
            v-if="
              supportedFeaturesOutbox &&
              product.mediaCollections &&
              product.mediaCollections.length > 0
            "
            @click.prevent="handleAttachAll"
            :class="{ active: isAttached }"
            type="text"
            native-type="button"
          >
            <i class="el-icon-custom-attach">
              <!--TODO Added new translation string "Add to Outbox" to Product section.-->
              <span class="sr-only sr-only-focusable">{{
                $t('productCardAttach')
              }}</span>
            </i>
          </el-button>
        </el-button-group>
      </div>
    </el-card>
  </div>
</template>

<script>
import products from './';
import user from '../user';
import outbox from '@/components/outbox';
import get from 'lodash.get';
import { mapActions, mapGetters, mapState } from 'vuex';
import fallbackJpg from '@/assets/images/fallbackVertical.jpg';
import mixins from '@/mixins';
import { starIconFilled } from '../../assets/icon-paths/star-icon';
import { buildProductDetailRoute } from './product.util';

export default {
  name: 'ProductCard',
  mixins: [mixins.supportedFeatures],
  data() {
    return {
      fallbackJpg,
    };
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(outbox.store.namespace, ['assets']),
    ...mapGetters(user.store.namespace, ['region']),
    product() {
      return this.$store.getters[`${products.store.namespace}/getProductById`](
        this.productId
      );
    },
    isFavorite() {
      return this.$store.getters[`${user.store.namespace}/productIsFavorite`](
        this.productId
      );
    },
    category() {
      return this.product && this.product.newProductCategory?.length > 0
        ? this.$store.getters[`${products.store.namespace}/getCategoryById`](
            this.product.newProductCategory[0].id
          )
        : '';
    },
    isAttached() {
      return !!this.assets[this.product.id];
    },
    categoryParents,
    mainImageUrl() {
      return get(this.product, 'mainImage.0.url');
    },
    productDetailRoute() {
      return buildProductDetailRoute(this.product || { id: this.productId });
    },
    starIconFilled() {
      return starIconFilled;
    },
  },
  methods: {
    ...mapActions(user.store.namespace, ['toggleFavorite']),
    ...mapActions(outbox.store.namespace, ['attachAllForProduct']),
    handleAttachAll() {
      this.attachAllForProduct(this.product);
    },
    handleToggleFavorite() {
      this.toggleFavorite(Number(this.product.id));
    },
  },
};

//////////

function categoryParents() {
  // Use this.category directly, which is the computed property category()
  const localCategory = this.category;

  if (
    !localCategory ||
    !localCategory.parents ||
    localCategory.parents.length === 0
  ) {
    return localCategory?.title || '';
  }
  const parents = localCategory.parents.slice().reverse() || [];
  let result = '';

  parents.forEach((category, i) => {
    result += i > 0 ? ' ' : '';
    result += category.title;
  });

  if (parents.length === 1) {
    result += ' ' + localCategory.title;
  }

  return result;
}
</script>

<style lang="scss" scoped>
.product {
  &__link {
    overflow: hidden;
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    padding-top: 63px;
  }
}

.el-button-group {
  width: 100%;

  .el-button {
    width: 50%;
    padding: 4px 0;
    border-right: 1px solid #dddddd;
    font-size: 20px;
    line-height: 20px;

    span {
      overflow: visible;
    }

    &:last-child {
      border-right: none;
    }
  }
}

.card__actions {
  .el-button {
    color: #aaa;

    &.active {
      color: #ed1c2e;
    }
  }
}
</style>
